import { ErrorData, ErrorDataOptions } from '@ddt-web/data-service';

import { Replacer } from '../engine/replacer';
import { OutputResult } from '../models/output-result.model';
import { ConditionType } from './condition-type';
import { Rule } from './rule';

/**
 * Rules can consist of multiple conditions. Any or all of these
 * conditions may be required for successful evaluation.
 */
export class CompositeRule implements Rule {
	public rules: Rule[] = [];
	public type: ConditionType;
	public output: OutputResult;
	public replacer: Replacer;
	private jsonArrayRegex = /(^\[)[^]*(\]$)/g;


	public evaluate(portfolioData: any, defaultValue?: any): OutputResult {
		try {
			switch (this.type) {
				case ConditionType.ALL:
					if (this.rules.every(r => r.evaluate(portfolioData, defaultValue))) {
						if (this.replacer) {
							this.applyReplacer(this.output.output, portfolioData);
							this.parseJsonArrayOutput(this.output.output);
						}
						return this.output;
					}
					break;
				case ConditionType.ANY:
					if (this.rules.some(r => r.evaluate(portfolioData, defaultValue))) {
						if (this.replacer) {
							this.applyReplacer(this.output.output, portfolioData);
							this.parseJsonArrayOutput(this.output.output);
						}
						return this.output;
					}
					break;
				default:
					console.warn('RULES_ENGINE_ERROR:Condition type not found');
					return new OutputResult(
						null,
						ErrorData.create({
							id: 'RULES_ENGINE_ERROR',
							success: false,
							allDataReturned: false,
							errorCodes: ['RULES_ENGINE_ERROR'],
							failureReason: 'RULES_ENGINE_ERROR:Condition type not found',
							debugMessage: 'RULES_ENGINE_ERROR:Composite rule evaluation: type not found'
						} as ErrorDataOptions)
					);
			}
		} catch (error) {
			return new OutputResult(
				null,
				ErrorData.create({
					id: 'RULES_ENGINE_ERROR',
					success: false,
					allDataReturned: false,
					errorCodes: ['RULES_ENGINE_ERROR'],
					failureReason: 'Evaluation and/or replacer error',
					debugMessage: this.output.output.type + ':' + (<Error>error).message
				} as ErrorDataOptions)
			);
		}
	}
	private applyReplacer(output, portfolioData): void {
		try {
			Object.keys(output).forEach(key => {
				output[key] = this.replacer.replace(output[key], portfolioData);
			});
		} catch (error) {
			throw new Error((<Error>error).message);
		}
	}

	public parseJsonArrayOutput(output): void {
		Object.keys(output).forEach(key => {
			if (typeof output[key] === 'string') {
				if (this.jsonArrayRegex.test(output[key])) {
					output[key] = JSON.parse(output[key]);
				}
			}
		});
	}
}
